'use client';

import React from 'react';
import { Box, Toolbar } from '@unity/cloud-ui';
import { styled } from '@unity/cloud-ui/styles';
import type { ProductHeaderDataType } from '@/lib/content-loader/types';
import themeConstants from '@/components/theme/theme-constants';
import { ProductHeaderDesktop } from './components/product-header-desktop';
import { ProductHeaderMobile } from './components/product-header-mobile';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  paddingLeft: 0,
  padding: theme.spacing(0.75, 1.5, 0.75, 1),
  justifyContent: 'space-between',
  backgroundColor: theme.vars.palette.background.paper,
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.vars.palette.divider}`,
  minHeight: theme.layout.headerHeight,
  height: theme.layout.headerHeight,
}));

export const ProductHeader = (props: ProductHeaderDataType) => {
  const { title, quickAccess, callToAction } = props;

  return (
    <Box
      component="header"
      top={{ xs: 0, md: themeConstants.layout.productHeaderHeight }}
      width="100%"
      zIndex={10}
      sx={{ position: { xs: 'sticky', md: 'fixed' } }}
    >
      <StyledToolbar disableGutters variant="dense">
        <Box data-testid="desktop-wrapper" display={{ xs: 'none', sm: 'none', md: 'flex' }} width="100%">
          <ProductHeaderDesktop title={title} quickAccess={quickAccess} callToAction={callToAction} />
        </Box>
        <Box data-testid="mobile-wrapper" display={{ xs: 'flex', sm: 'flex', md: 'none' }} width="100%">
          <ProductHeaderMobile title={title} quickAccess={quickAccess} callToAction={callToAction} />
        </Box>
      </StyledToolbar>
    </Box>
  );
};
